//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data () {
    return {
      traderData: {}
    }
  },
  created () {
  },
  mounted () {
    this.getExchange()
  },
  methods: {
    async getExchange () { // 获取交易商数据
      const res = await this.$api.login.userExchange()
      this.traderData = res
    }
  }
}
